{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Atšaukti",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integracijos",
    "DESCRIPTION": "Kontaktų centras integruojamas su daugeliu įrankių ir paslaugų, kad jūsų komanda dirbtų efektyviau. Peržiūrėkite toliau pateiktą sąrašą ir sukonfigūruokite mėgstamas programas.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Prenumeruoti įvykiai",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Atšaukti",
        "DESC": "Webhook įvykiai suteikia jums realaus laiko informaciją apie tai, kas vyksta jūsų paskyroje. Norėdami sukonfigūruoti atgalinį skambinimą, įveskite tinkamą URL.",
        "SUBSCRIPTIONS": {
          "LABEL": "Įvykiai",
          "EVENTS": {
            "INBOX_CREATED": "Gautų laiškų aplankas sukurtas",
            "CONVERSATION_CREATED": "Pokalbis sukurtas",
            "CONVERSATION_STATUS_CHANGED": "Pokalbio būsena pakeista",
            "CONVERSATION_UPDATED": "Pokalbis atnaujintas",
            "MESSAGE_CREATED": "Pranešimas sukurtas",
            "MESSAGE_UPDATED": "Pranešimas atnaujintas",
            "WEBWIDGET_TRIGGERED": "Tiesioginio pokalbio valdiklis, kurį atidarė vartotojas",
            "CONTACT_CREATED": "Sukurtas kontaktas",
            "CONTACT_UPDATED": "Kontaktas atnaujintas",
            "JARABOT_EVENT": "Vidiniai įvykiai"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Prašome įvesti tesingą URL adresą"
        },
        "EDIT_SUBMIT": "Atnaujinti webhook",
        "ADD_SUBMIT": "Sukurti webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfigūruoti",
      "HEADER": "Webhook nustatymai",
      "HEADER_BTN_TXT": "Pridėti naują webhook",
      "LOADING": "Pridėtų webhooks gavimas",
      "SEARCH_404": "Šią užklausą atitinkančių elementų nėra",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks yra HTTP užklausos, kurias galima nustatyti kiekvienai paskyrai. Juos suaktyvina tokie įvykiai kaip pranešimų kūrimas. Šiai paskyrai galite sukurti daugiau nei vieną webhook. <br /><br /> Norėdami sukurti <b>webhook</b>, spustelėkite mygtuką <b>Pridėti naują webhook</b>. Taip pat galite pašalinti bet kurį esamą webhook spustelėdami mygtuką Ištrinti.</p>",
      "LIST": {
        "404": "Šioje paskyroje nėra sukonfigūruotų webhook.",
        "TITLE": "Tvarkykite webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook endpoint",
          "ACTIONS": "Veiksmai"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Redaguoti",
        "TITLE": "Redaguoti webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfigūracija sėkmingai atnaujinta",
          "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
        }
      },
      "ADD": {
        "CANCEL": "Atšaukti",
        "TITLE": "Pridėti naują webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfigūracija pridėta sėkmingai",
          "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Ištrinti",
        "API": {
          "SUCCESS_MESSAGE": "Webhook ištrintas sėkmingai",
          "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
        },
        "CONFIRM": {
          "TITLE": "Patvirtinti Ištrynimą",
          "MESSAGE": "Ar tikrai norite ištrinti webhook? ({webhookURL})",
          "YES": "Taip, Trinti ",
          "NO": "Ne, Išsaugoti"
        }
      },
      "DISABLED_BADGE": "Išjungta",
      "DISABLED_REASON": "Automatiškai išjungta po {count} paeiliui įvykusių klaidų. Paskutinė klaida: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Įjungti",
        "API": {
          "SUCCESS_MESSAGE": "Webhook sėkmingai įjungtas",
          "ERROR_MESSAGE": "Nepavyko įjungti webhook, bandykite dar kartą vėliau"
        }
      }
    },
    "SLACK": {
      "DELETE": "Ištrinti",
      "DELETE_CONFIRMATION": {
        "TITLE": "Ištrinkite integraciją",
        "MESSAGE": "Ar tikrai norite ištrinti integraciją? Tai padarius prarasite prieigą prie pokalbių Slack darbo erdvėje."
      },
      "HELP_TEXT": {
        "TITLE": "Slack integracijos naudojimas",
        "BODY": "Naudojant šią integraciją, visi jūsų gaunami pokalbiai bus sinchronizuojami su ***{selectedChannelName}*** kanalu jūsų Slack darbo erdvėje. Visus pokalbius su klientais galite tvarkyti tiesiai kanale ir niekada nepraleisti nė vieno pranešimo.\n\nPagrindinės integracijos funkcijos:\n\n**Atsakykite į pokalbius tiesiai iš Slack:** Norėdami atsakyti į pokalbį ***{selectedChannelName}*** Slack kanale, parašykite savo pranešimą ir išsiųskite jį kaip giją. Taip klientui bus išsiųstas atsakymas per Kontaktų centrą. Tai labai paprasta!\n\n **Kurkite privačias pastabas:** Jei vietoj atsakymų norite kurti privačias pastabas, pradėkite pranešimą žodžiu ***`note:`***. Taip jūsų pranešimas liks privatus ir klientas jo nematys.\n\n**Susiekite agento profilį:** Jei Slack atsakęs asmuo turi agento profilį Kontaktų centre su tuo pačiu el. pašto adresu, atsakymai bus automatiškai susieti su tuo agento profiliu. Taip galite lengvai sekti, kas, ką ir kada pasakė. Jei atsakęs asmuo neturi susieto agento profilio, klientas matys atsakymus iš roboto profilio.",
        "SELECTED": "pasirinkta"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Pasirinkite kanalą",
        "UPDATE": "Atnaujinti",
        "BUTTON_TEXT": "Prijunkite kanalą",
        "DESCRIPTION": "Jūsų Slack darbo erdvė dabar susieta su Kontaktų centru. Tačiau integracija šiuo metu neaktyvi. Norėdami aktyvuoti integraciją ir prijungti kanalą, spustelėkite toliau esantį mygtuką.\n\n**Pastaba:** Jei bandote prijungti privatų kanalą, prieš atlikdami šį veiksmą pridėkite mūsų programą į Slack kanalą.",
        "ATTENTION_REQUIRED": "Reikalingas dėmesys",
        "EXPIRED": "Jūsų Slack integracijos galiojimo laikas baigėsi. Norėdami ir toliau gauti pranešimus Slack, ištrinkite integraciją ir vėl prijunkite savo darbo erdvę."
      },
      "UPDATE_ERROR": "Atnaujinant integraciją įvyko klaida, bandykite dar kartą",
      "UPDATE_SUCCESS": "Kanalas sėkmingai prijungtas",
      "FAILED_TO_FETCH_CHANNELS": "Gaunant kanalus iš Slack įvyko klaida, bandykite dar kartą"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI pagalba",
      "WITH_AI": " {option} su AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Atsakymo pasiūlymas",
        "SUMMARIZE": "Apibendrinti",
        "REPHRASE": "Pagerinkite rašymą",
        "FIX_SPELLING_GRAMMAR": "Pataisykite rašybą ir gramatiką",
        "SHORTEN": "Sutrumpinti",
        "EXPAND": "Išskleisti",
        "MAKE_FRIENDLY": "Pakeisti pranešimo toną į draugišką",
        "MAKE_FORMAL": "Naudokite oficialų toną",
        "SIMPLIFY": "Supaprastinti",
        "TRANSLATE": "Versti",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Versti į daugumos kalbą"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Turinio juodraštis",
        "GENERATED_TITLE": "Sugeneruotas turinys",
        "AI_WRITING": "AI rašo",
        "BUTTONS": {
          "APPLY": "Naudoti šį pasiūlymą",
          "CANCEL": "Atšaukti"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integruoti su OpenAI",
        "DESC": "Suteikite savo valdymo skydeliui pažangias AI funkcijas naudodami OpenAI GPT modelius. Norėdami pradėti, įveskite savo OpenAI paskyros API raktą.",
        "KEY_PLACEHOLDER": "Įveskite savo OpenAI API raktą",
        "BUTTONS": {
          "NEED_HELP": "Reikia pagalbos?",
          "DISMISS": "Atsisakyti",
          "FINISH": "Baigti nustatymus"
        },
        "DISMISS_MESSAGE": "OpenAI integraciją galite nustatyti vėliau, kada tik norėsite.",
        "SUCCESS_MESSAGE": "OpenAI integracija nustatyta sėkmingai"
      },
      "TITLE": "Tobulinti naudojant AI",
      "SUMMARY_TITLE": "Apibendrinimas naudojant AI",
      "REPLY_TITLE": "Atsakymo pasiūlymas naudjant AI",
      "SUBTITLE": "Patobulintas atsakymas bus sukurtas naudojant AI, remiantis dabartiniu juodraščiu.",
      "TONE": {
        "TITLE": "Tonas",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionalas",
          "FRIENDLY": "Draugiškas"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generuoti",
        "GENERATING": "Sukurti...",
        "CANCEL": "Atšaukti"
      },
      "GENERATE_ERROR": "Įvyko klaida apdorojant turinį, pabandykite dar kartą"
    },
    "DELETE": {
      "BUTTON_TEXT": "Ištrinti",
      "API": {
        "SUCCESS_MESSAGE": "Integracija sėkmingai ištrinta"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Sujungti"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Informacinio skydelio programos",
      "HEADER_BTN_TXT": "Pridėkite naują informacinio skydelio programą",
      "SIDEBAR_TXT": "<p><b>Informacinio skydelio programos</b></p><p>Informacinio skydelio programos leidžia organizacijoms įterpti programą į Chatwood valdymo skydelį, kad klientų aptarnavimo agentams būtų suteiktas kontekstas. Ši funkcija leidžia savarankiškai kurti programą ir įterpti informaciją apie vartotoją, jo užsakymus ar mokėjimų istoriją.</p><p>Kai įterpiate programą naudodami Chatwood valdymo skydelį, programa gaus pokalbio kontekstą ir įvykio nuorodas. Įdiekite pranešimo įvykio nuorodas savo puslapyje, kad gautumėte kontekstą.</p><p>Jei norite pridėti naują informacinio skydelio programą, spustelėkite mygtuką \"Pridėti naują skydelio programą\".</p>",
      "DESCRIPTION": "Informacinio skydelio programos leidžia organizacijoms įterpti programą į valdymo skydelį, kad klientų aptarnavimo agentams būtų suteiktas kontekstas. Ši funkcija leidžia savarankiškai kurti programą ir įterpti informaciją apie vartotoją, jo užsakymus ar mokėjimų istoriją.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Šioje paskyroje nėra sukonfigūruotų informacinio skydelio programų",
        "LOADING": "Gaunamos informacinio skydelio programos...",
        "TABLE_HEADER": {
          "NAME": "Vardas",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Redaguoti programą",
        "DELETE_TOOLTIP": "Ištrinti programą"
      },
      "FORM": {
        "TITLE_LABEL": "Vardas",
        "TITLE_PLACEHOLDER": "Įveskite informacinio skydelio programos pavadinimą",
        "TITLE_ERROR": "Reikalingas informacinio skydelio programos pavadinimas",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Įveskite URL adresą, kuriuo pasiekiama jūsų programa",
        "URL_ERROR": "Reikalingas tinkamas URL"
      },
      "CREATE": {
        "HEADER": "Pridėkite naują informacinio skydelio programą",
        "FORM_SUBMIT": "Pateikti",
        "FORM_CANCEL": "Atšaukti",
        "API_SUCCESS": "Informacinio skydelio programa sėkmingai sukonfiguruota",
        "API_ERROR": "Nepavyko sukurti programos. Pabandykite dar kartą vėliau"
      },
      "UPDATE": {
        "HEADER": "Tvarkyti informacinio skydelio programą",
        "FORM_SUBMIT": "Atnaujinti",
        "FORM_CANCEL": "Atšaukti",
        "API_SUCCESS": "Informacinio skydelio programa atnaujinta sėkmingai",
        "API_ERROR": "Nepavyko atnaujinti programos. Pabandykite dar kartą vėliau"
      },
      "DELETE": {
        "CONFIRM_YES": "Taip, Trinti",
        "CONFIRM_NO": "Ne, Išsaugoti",
        "TITLE": "Patvirtinti Ištrynimą",
        "MESSAGE": "Ar tikrai norite ištrinti programą - {appName}?",
        "API_SUCCESS": "Informacinio skydelio programa ištrinta sėkmingai",
        "API_ERROR": "Nepavyko ištrinti programos. Pabandykite dar kartą vėliau"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Sukurti",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Nuoroda",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Pavadinimas",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Yra reikalingas pavadinimas"
          },
          "DESCRIPTION": {
            "LABEL": "Aprašymas",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Komanda",
            "PLACEHOLDER": "Pasirinkite komandą",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Prioritetas",
            "PLACEHOLDER": "Pasirinkti prioritetą",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Etiketė",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Būsena",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Sukurti",
        "CANCEL": "Atšaukti",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Būsena",
        "PRIORITY": "Prioritetas",
        "ASSIGNEE": "Assignee",
        "LABELS": "Etiketės",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Taip, Trinti",
        "CANCEL": "Atšaukti"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Išsiųsti pranešimą...",
      "EMPTY_MESSAGE": "Generuojant atsakymą įvyko klaida. Bandykite dar kartą.",
      "LOADER": "Captain is thinking",
      "YOU": "Jūs",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Atšaukti",
      "CREATE": "Sukurti",
      "EDIT": "Atnaujinti"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Taip, Trinti",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Funkcijos",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Taip, Trinti",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Ištrinti",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Taip, Trinti",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Visi"
      },
      "STATUS": {
        "TITLE": "Būsena",
        "PENDING": "Laukiama",
        "APPROVED": "Approved",
        "ALL": "Visi"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Atsijungti"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Taip, Trinti",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Gautų laiškų aplankas",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
